var trenshold = 0;

// override the function in window.PXUTheme.jsAjaxCart
jQuery.extend(window.PXUTheme.jsAjaxCart, {
  addToCart: function ($addToCartForm) {
    const $addToCartBtn = $addToCartForm.find('.button--add-to-cart');

    $addToCartForm.removeClass('shopify-product-form--unselected-error');

    if ($addToCartBtn[0].hasAttribute('data-options-unselected')) {
      const cartWarning = `<p class="cart-warning__message animated bounceIn">${window.PXUTheme.translation.select_variant}</p>`;

      $('.warning').remove();

      $addToCartForm
        .addClass('shopify-product-form--unselected-error')
        .find('.cart-warning')
        .html(cartWarning);

      $addToCartBtn
        .removeAttr('disabled')
        .removeClass('disabled');

      $addToCartBtn.find('.icon')
        .removeClass('zoomOut')
        .addClass('zoomIn');

      $addToCartBtn
        .find('span:not(.icon)')
        .text($addToCartBtn.data('label'))
        .removeClass('zoomOut')
        .addClass('zoomIn');
    } else {
      $.ajax({
        url: '/cart/add.js',
        dataType: 'json',
        cache: false,
        type: 'post',
        data: $addToCartForm.serialize(),
        beforeSend: function () {
          $addToCartBtn
            .attr('disabled', 'disabled')
            .addClass('disabled');

          $addToCartBtn.find('span')
            .removeClass("fadeInDown")
            .addClass('animated zoomOut');
        },
        success: function (product) {
          addTrenshold();
          let $el = $('[data-ajax-cart-trigger]');

          $addToCartBtn
            .find('.checkmark')
            .addClass('checkmark-active');

          function addedToCart() {

            if (!isScreenSizeLarge()) {
              $el = $('.mobile-header [data-ajax-cart-trigger]');
              window.PXUTheme.scrollToTop($el);
            } else {
              $el = $('[data-ajax-cart-trigger]');
            }

            $el.addClass('show-mini-cart');

            $addToCartBtn.find('span')
              .removeClass('fadeInDown');
          }

          window.setTimeout(function () {
            $addToCartBtn
              .removeAttr('disabled')
              .removeClass('disabled');

            $addToCartBtn.find('.checkmark')
              .removeClass('checkmark-active');

            $addToCartBtn.find('.text, .icon')
              .removeClass('zoomOut')
              .addClass('fadeInDown');

            $addToCartBtn.on('webkitAnimationEnd oanimationend msAnimationEnd animationend', addedToCart);

          }, 1000);

          if (window.PXUTheme.jsCart) {
            $.ajax({
              dataType: "json",
              async: false,
              cache: false,
              dataType: 'html',
              url: "/cart",
              success: function (html) {
                const cartForm = $(html).find('.cart__form');
                $('.cart__form').replaceWith(cartForm);

              }
            });
          }

        },
        error: function (XMLHttpRequest) {
          let response = eval('(' + XMLHttpRequest.responseText + ')');
          response = response.description;

          const cartWarning = `<p class="cart-warning__message animated bounceIn">${response.replace('All 1 ', 'All ')}</p>`;

          $('.warning').remove();

          $addToCartForm
            .find('.cart-warning')
            .html(cartWarning);

          $addToCartBtn
            .removeAttr('disabled')
            .removeClass('disabled');

          $addToCartBtn.find('.icon')
            .removeClass('zoomOut')
            .addClass('zoomIn');

          $addToCartBtn
            .find('span:not(.icon)')
            .text($addToCartBtn.data('label'))
            .removeClass('zoomOut')
            .addClass('zoomIn');
        }
      });
    }
  },
  removeFromCart: function (lineID, callback) {
    $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      data: 'quantity=0&line=' + lineID,
      dataType: 'json',
      success: function (cart) {
        window.PXUTheme.jsAjaxCart.updateView();
        updateTrenshold();
      },
      error: function (XMLHttpRequest, textStatus) {
        var response = eval('(' + XMLHttpRequest.responseText + ')');
        response = response.description;

      }
    });
  }
});

jQuery.extend(window.PXUTheme.quantityBox, {
  updateCart: function (lineID, quantity) {
    $('.quantity-warning').removeClass('animated bounceIn');
    $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      data: `quantity=${quantity}&line=${lineID}`,
      dataType: 'json',
      success: function (cart) {
        let newQuantity = 0;
        let itemsLeftText = '';
        let quantityWarning = $(`[data-line-item="${lineID}"]`).find('.quantity-warning');
        let $quantityBox = $(`[data-line-item="${lineID}"]`).find('.product-quantity-box');
        let $currentDiscount = $('.cart__form').data('currentDiscount'); //check to see if there are correct amount of products in array

        const cartItemsLineID = lineID - 1;
        updateTrenshold();
        if (typeof cart.items[cartItemsLineID] !== "undefined") {
          newQuantity = cart.items[cartItemsLineID].quantity;
        }

        for (let i = 0; i < cart.items.length; i++) {
          if (i != cartItemsLineID) {
            if (cart.items[i].id == cart.items[cartItemsLineID].id) {
              newQuantity += cart.items[i].quantity;
            }
          }
        }

        if (quantity > 0 && quantity != newQuantity) {
          //Check if total discount has changed
          if (cart.total_discount <= $currentDiscount) {
            if (newQuantity == 1) {
              itemsLeftText = window.PXUTheme.translation.product_count_one;
              quantityWarning.text(`${newQuantity} ${itemsLeftText}`);
              $('.quantity-minus', $quantityBox).attr('disabled', true);
            } else {
              itemsLeftText = window.PXUTheme.translation.product_count_other;
              quantityWarning.text(`${newQuantity} ${itemsLeftText}`);
            }
          }
        } //Update total discount value


        $('.cart__form').data('currentDiscount', cart.total_discount); // Apply quantity warning

        quantityWarning.addClass('animated bounceIn');

        if (typeof window.PXUTheme.jsAjaxCart !== 'undefined') {
          window.PXUTheme.jsAjaxCart.updateView();
        }

        if (window.PXUTheme.jsCart) {
          window.PXUTheme.jsCart.updateView(cart, lineID);
        }
      },
      error: function (XMLHttpRequest, textStatus) {
        var response = eval('(' + XMLHttpRequest.responseText + ')');
        response = response.description;
      }
    });
  }
})

function addTrenshold() {
  var productFirst = $('.ajax-cart').attr('data-trenshold-product-first');
  var productSecond = $('.ajax-cart').attr('data-trenshold-product-second');
  var $data = {};
  jQuery.getJSON('/cart.js', function (cart) {
    var totalPrice = 0;
    var items = cart.items;
    for (item of items) {
      if (item.variant_id != productFirst && item.variant_id != productSecond) {
        totalPrice += item.final_line_price / 100;
      }
    }

    // Check data
    if (productFirst != '' && !checkProductInCart(productFirst, items)) {
      if (productSecond != '' && !checkProductInCart(productSecond, items)) {
        var $data = {
          items: [
            {
              quantity: 1,
              id: productFirst
            },
            {
              quantity: 1,
              id: productSecond
            }
          ]
        }
      } else {
        var $data = {
          items: [
            {
              quantity: 1,
              id: productFirst
            }
          ]
        }
      }
    } else if (productSecond != '' && !checkProductInCart(productSecond, items)) {
      var $data = {
        items: [
          {
            quantity: 1,
            id: productSecond
          }
        ]
      }
    }

    if (totalPrice >= trenshold) {
      //Add trenshold
      if (!checkProductInCart(productFirst, items) || !checkProductInCart(productSecond, items)) {
        addItemToCart($data);
      } else {
        window.PXUTheme.jsAjaxCart.showDrawer();
        window.PXUTheme.jsAjaxCart.updateView();
      }
    } else {
      window.PXUTheme.jsAjaxCart.showDrawer();
      window.PXUTheme.jsAjaxCart.updateView();
    }
  });
}

function updateTrenshold() {
  jQuery.getJSON('/cart.js', function (cart) {
    var totalPrice = 0;
    var items = cart.items;
    var productFirst = $('.ajax-cart').attr('data-trenshold-product-first');
    var productSecond = $('.ajax-cart').attr('data-trenshold-product-second');

    for (item of items) {
      if (item.variant_id != productFirst && item.variant_id != productSecond) {
        totalPrice += item.final_line_price / 100
      }

      if (checkProductInCart(productFirst, items)) var productFirstId = item.key;
      if (checkProductInCart(productSecond, items)) var productSecondId = item.key;
    }

    var dataUpdate = {};
    // Check data
    if (checkProductInCart(productFirst, items)) {
      if (checkProductInCart(productSecond, items)) {
        dataUpdate = {
          'updates': {
            [parseInt(productFirstId)]: 0,
            [parseInt(productSecondId)]: 0
          }
        }
      } else {
        dataUpdate = {
          'updates': {
            [parseInt(productFirstId)]: 0
          }
        }
      }
    } else if (checkProductInCart(productSecond, items)) {
      dataUpdate = {
        'updates': {
          [parseInt(productSecondId)]: 0
        }
      }
    }

    if (totalPrice < trenshold) {
      //Remove trenshold
      if (checkProductInCart(productFirst, items) || checkProductInCart(productSecond, items)) {
        removeItemToCart(dataUpdate)
      }
    } else {
      //Add trenshold
      if (productFirst != '' && !checkProductInCart(productFirst, items)) {
        if (productSecond != '' && !checkProductInCart(productSecond, items)) {
          var $data = {
            items: [
              {
                quantity: 1,
                id: productFirst
              },
              {
                quantity: 1,
                id: productSecond
              }
            ]
          }
        } else {
          var $data = {
            items: [
              {
                quantity: 1,
                id: productFirst
              }
            ]
          }
        }
      } else if (productSecond != '' && !checkProductInCart(productSecond, items)) {
        var $data = {
          items: [
            {
              quantity: 1,
              id: productSecond
            }
          ]
        }
      }

      if (!checkProductInCart(productFirst, items) || !checkProductInCart(productSecond, items)) {
        if ($data && $data.items.length > 0) addItemToCart($data);
      } else {
        window.PXUTheme.jsAjaxCart.showDrawer();
        window.PXUTheme.jsAjaxCart.updateView();
      }
    }
  });
}

function checkProductInCart(variantId, items) {
  var check = false;
  for (item of items) {
    if (item.variant_id == variantId) {
      check = true;
      break;
    }
  }

  return check;
}

/**
 * 
 * @param $data
 * @result add trenshold products to card
 */
function addItemToCart($data) {
  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: $data,
    dataType: 'json',
    success: function (data) {
      window.PXUTheme.jsAjaxCart.showDrawer();
      window.PXUTheme.jsAjaxCart.updateView();
    }
  });
}

/**
 * 
 * @param $data 
 * @result remove trenshold products to card
 */
function removeItemToCart($data) {
  $.ajax({
    type: 'POST',
    url: '/cart/update.js',
    data: $data,
    dataType: 'json',
    success: function (data) {
      window.PXUTheme.jsAjaxCart.showDrawer();
      window.PXUTheme.jsAjaxCart.updateView();
    },
    error: function (XMLHttpRequest, textStatus) {
      var response = eval('(' + XMLHttpRequest.responseText + ')');
      response = response.description;
    }
  });
}

$(document).ready(function () {
  $('.image-with-text-items').owlCarousel({
    loop: true,
    nav: false,
    dots: false,
    margin: 32,
    items: 4,
    responsive: {
      0: {
        items: 2,
        margin: 10
      },
      768: {
        items: 3,
        margin: 20
      },
      1024: {
        items: 4,
        margin: 32
      }
    }
  });
  $('.outstanding-functions .outstanding-functions-items').addClass('owl-carousel');
  $('.outstanding-functions .outstanding-functions-items').owlCarousel({
    loop: false,
    nav: false,
    dots: false,
    margin: 20,
    items: 4,
    responsive: {
      0: {
        items: 1,
        margin: 20
      },
      768: {
        items: 2,
        margin: 20
      }
    }
  });

  // const textPath = document.querySelector("#text-path");

  // const startOffset = -1200.00,
  //   endOffset = 1200,
  //   fps = 1,
  //   speed = 0.2;

  // var currentOffset = startOffset;

  // if ($('#text-path').length > 0) {
  //   setInterval(() => {
  //     if (currentOffset >= endOffset) {
  //       currentOffset = startOffset;
  //     }
  //     textPath.setAttribute("startOffset", currentOffset);
  //     currentOffset += speed;
  //   }, fps)
  // }

  $('.button-play-video').click(function (e) {
    e.preventDefault();
    if ($(this).prev('video')[0].paused) {
      $(this).prev('video')[0].play();
      $(this).prev('video').addClass('playing');
    } else {
      $(this).prev('video')[0].pause();
      $(this).prev('video').revoveClass('playing');
    }
  })

  $('.video-with-text-left .button').click(function (e) {
    e.preventDefault();
    if ($(this).closest('.video-with-text_section').find('video')[0].paused) {
      $(this).closest('.video-with-text_section').find('video')[0].play();
      $(this).closest('.video-with-text_section').find('video').addClass('playing');
    } else {
      $(this).closest('.video-with-text_section').find('video')[0].pause();
      $(this).closest('.video-with-text_section').find('video').revoveClass('playing');
    }
  })
})
